import React, { useState } from 'react'
import { useUser } from '../../context/user'
import { useTranslation } from 'react-i18next'
import { Oval } from 'react-loader-spinner'
import { getById } from '../../server/server'
import i18n from '../../i18n'
import { useAuth } from '../../context/auth'
import LoginWrapper from './LoginWrapper'
import { useHistory } from 'react-router-dom'
import { Trans } from 'react-i18next'

function Login() {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const { loginUser } = useAuth()
    const [loading, setLoading] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const [rememberMe, setRememberMe] = useState(false)
    const [showPassword, setShowPassword] = useState(false)
    const { setUser } = useUser()
    const { t } = useTranslation()

    const history = useHistory()

    const handleSubmit = async (e) => {
        e.preventDefault()
        setLoading(true)
        if (!email || !password) {
            setErrorMessage('Please enter username and password')
            setLoading(false)
            return
        }
        const resp = await loginUser({ email, password })
        if (!resp.success) {
            setErrorMessage(resp.data)
            setLoading(false)
        } else {
            const user = resp.data
            localStorage.setItem('temporaryAccess', !rememberMe)
            if (user.new_password_required) {
                setPassword('')
                history.push('/enter-new-password', { email, token: user.token })
            } else {
                localStorage.setItem('userToken', user.token)
                setUser(user)
                loadInstitution(user)
            }
            setLoading(false)
        }
    }
    const loadInstitution = async (user) => {
        const resp = await getById({
            collection: 'institutions',
            id: user.institution_id,
        })
        if (resp.status === 200) {
            if (!!resp?.data?.locale) {
                i18n.changeLanguage(resp?.data?.locale)
                localStorage.setItem('locale', resp?.data?.locale)
            }
        }
    }

    const changeRememberMe = (e) => {
        const target = e.target
        const value = target.type === 'checkbox' ? target.checked : target.value
        setRememberMe(value)
    }

    const toggleRememberMe = () => {
        setRememberMe(!rememberMe)
    }
    const changeShowPassword = (e) => {
        const target = e.target
        const value = target.type === 'checkbox' ? target.checked : target.value
        setShowPassword(value)
    }

    const toggleShowPassword = () => {
        setShowPassword(!showPassword)
    }
    return (
        <LoginWrapper>
            <>
                <div className="">
                    <div className="modal-title">{t('login')}</div>
                    <div className="modal-subtitle">{t('Enter credentials you received from school')}</div>
                    <div className="sign-up-section">
                        <div className="login-form">
                            <form onSubmit={handleSubmit}>
                                <div className="login-form-element-holder" style={{ marginBottom: '30px' }}>
                                    <label>{t('email')}</label>
                                    <input placeholder={t('email')} value={email} onChange={(e) => setEmail(e.target.value)} />
                                </div>
                                <div className="login-form-element-holder" style={{ marginBottom: '25px' }}>
                                    <label>{t('password')}</label>
                                    <input placeholder={t('password')} value={password} type={showPassword ? 'text' : 'password'} onChange={(e) => setPassword(e.target.value)} />
                                </div>
                                <div className="login-checkbox-container">
                                    <div className="remember-me-container">
                                        <input type="checkbox" checked={showPassword} onChange={changeShowPassword} />
                                        <label htmlFor="checkbox" onClick={toggleShowPassword}>
                                            {t('showPassword')}
                                        </label>
                                    </div>
                                    <div className="remember-me-container">
                                        <input type="checkbox" checked={rememberMe} onChange={changeRememberMe} />
                                        <label htmlFor="checkbox" onClick={toggleRememberMe}>
                                            {t('rememberMe')}
                                        </label>
                                    </div>
                                </div>
                                <div className="error-message">{t(errorMessage)}</div>
                                <div className="login-form-submit-button">
                                    <button className="auth-form-button">
                                        {loading ? <Oval strokeWidth={5} secondaryColor="#7ec5c6" color="#7ec5c6" height={30} width={30} /> : t('login')}
                                    </button>
                                </div>
                            </form>
                        </div>
                        <div>
                            <div className="login-missing-text">
                                <span className="login-missing-text-q">{t('forgotPassword')}</span>
                                <span
                                    className="login-missing-text-action"
                                    onClick={() => {
                                        history.push('/new-password')
                                    }}
                                >
                                    {t('requestNewPassword')}
                                </span>
                            </div>
                            {/* <p className="login-link-website" onClick={() => window.open('https://upstrive.de/for-schools-wellbeing-upstrive-education/', '_blank')}>
                                <Trans
                                    i18nKey="visitOurWebsiteForMoreDetails"
                                    components={{
                                        white: <span style={{ color: 'white' }} />,
                                    }}
                                />
                            </p> */}
                        </div>
                    </div>
                </div>
            </>
        </LoginWrapper>
    )
}

export default Login
